import React, { CSSProperties } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { PdfPreviewContent } from '../PdfPreviewContent';
import { BASE_URL, UPLOAD_IMAGES } from '../../utils/constants';
import { useIES } from '../../hooks/useIES';

interface ExtendedCSSProperties extends CSSProperties {
  '@media print'?: CSSProperties;
}

const styles: { [key: string]: ExtendedCSSProperties } = {
  cardContainer: {
    display: 'flex',
    height: '100vh',
    padding: '20px'
  } as CSSProperties,
  
  idCard: {
    height: '320px',
    width: '626px',
    borderRadius: '12px',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    position: 'relative',
    margin: '10px 10px 8px'
  } as CSSProperties,
  
  head: {
    backgroundColor: 'rgba(44, 53, 48, 0.603)',
    height: '25%',
    display: 'flex',
    flexDirection: 'column'
  } as CSSProperties,
  
  mainContent: {
    background: 'linear-gradient(white, rgba(44, 48, 42, 0.329))',
    height: '75%'
  } as CSSProperties,
  
  headUpper: {
    height: '75%',
    display: 'flex'
  } as CSSProperties,
  
  iesIcon: {
    height: '90%',
    margin: '5px 0 5px 13px'
  } as CSSProperties,
  
  collegeName: {
    color: 'white',
    fontSize: '36px',
    fontFamily: '"Roboto Condensed", sans-serif',
    fontWeight: 'bold',
    letterSpacing: '1.5px'
  } as CSSProperties,
  
  certified: {
    color: 'rgb(7, 2, 2)',
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: '18px',
    marginTop: '5px'
  } as CSSProperties,
  
  studentInfoAndImg: {
    display: 'flex',
    height: '199px',
    fontFamily: '"Roboto", sans-serif',
    color: '#1A2D5A',
    fontWeight: 600
  } as CSSProperties,
  
  studentInfo: {
    width: '70%',
    fontSize: '14px'
  } as CSSProperties,
  
  studentImg: {
    width: '30%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  } as CSSProperties,
  
  dInfo: {
    display: 'flex',
    padding: '0 20px'
  } as CSSProperties,
  
  dInfoTitle: {
    width: '120px'
  } as CSSProperties,
  
  dInfoValue: {
    marginLeft: '10px',
    width: '274px'
  } as CSSProperties,
  
  profileImage: {
    height: '135px',
    width: '135px',
    backgroundSize: 'cover',
    border: '1px solid #1A2D5A'
  } as CSSProperties,
  
  upper: {
    textTransform: 'uppercase'
  } as CSSProperties
};

// Adicione os estilos de impressão separadamente
const printStyles = document.createElement('style');
printStyles.innerHTML = `
  @media print {
    .cardContainer {
      padding: 0;
      height: auto;
    }
    .idCard {
      margin: 0;
      border-radius: 0;
      page-break-inside: avoid;
    }
    .head {
      background-color: rgba(44, 53, 48, 0.8);
    }
    .mainContent {
      background: white;
    }
  }
`;
document.head.appendChild(printStyles);

export const StudentCard = () => {
  const enrollmentData = useSelector((state: RootState) => state.student);
  const { IES, isLoading } = useIES();
  return (
    <PdfPreviewContent>
    <div className="cardContainer" style={styles.cardContainer}>
      <div className="idCard" style={styles.idCard}>
        <div className="head" style={styles.head}>
          <div style={styles.headUpper}>
            <img 
             src={`${IES.LOGO}`}
             alt="Institution Icon" style={styles.iesIcon} />
            <div>
              <div style={styles.collegeName}>Esura local</div>
            </div>
          </div>
        </div>
        <div className="mainContent" style={styles.mainContent}>
          <div style={styles.certified}>Cartão de estudante</div>
          <div style={styles.studentInfoAndImg}>
            <div style={styles.studentInfo}>
              <div style={styles.dInfo}>
                <div style={styles.dInfoTitle}>Nome</div>
                :<div style={{...styles.dInfoValue, ...styles.upper}}>{enrollmentData.user?.name}</div>
              </div>
              <div style={styles.dInfo}>
                <div style={styles.dInfoTitle}>Departamento</div>
                :<div style={styles.dInfoValue}>{enrollmentData?.enrollment?.departament}</div>
              </div>
              <div style={styles.dInfo}>
                <div style={styles.dInfoTitle}>Curso</div>
                :<div style={styles.dInfoValue}>{enrollmentData?.enrollment?.course}</div>
              </div>
              <div style={styles.dInfo}>
                <div style={styles.dInfoTitle}>Ano</div>
                :<div style={styles.dInfoValue}>{new Date().getFullYear()}</div>
              </div>
              <div style={styles.dInfo}>
                <div style={styles.dInfoTitle}>Telemóvel</div>
                :<div style={styles.dInfoValue}>{enrollmentData.user?.phoneNumber}</div>
              </div>
              <div style={styles.dInfo}>
                <div style={styles.dInfoTitle}>Email</div>
                :<div style={styles.dInfoValue}>{enrollmentData.user?.email}</div>
              </div>
            </div>
            <div style={styles.studentImg}>
              <div>{enrollmentData.enrollment?.student}</div>
              <div style={styles.profileImage} />
              <div>Assinatura</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </PdfPreviewContent>
  );
};

export default StudentCard;